import { render, staticRenderFns } from "./material-application-form.vue?vue&type=template&id=2abb43d8&scoped=true"
import script from "./material-application-form.vue?vue&type=script&lang=js"
export * from "./material-application-form.vue?vue&type=script&lang=js"
import style0 from "./material-application-form.vue?vue&type=style&index=0&id=2abb43d8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2abb43d8",
  null
  
)

export default component.exports